import tokenData from '../../design-tokens/base-tokens.json';
export let typography = {
    fontFamily: tokenData.tokens.typography.fontFamily,
    fontSize: 16,
    h1: tokenData.tokens.typography.heading3xl,
    h2: tokenData.tokens.typography.heading2xl,
    h3: tokenData.tokens.typography.headingXl,
    h4: tokenData.tokens.typography.headingLg,
    h5: tokenData.tokens.typography.headingMd,
    h6: tokenData.tokens.typography.heading,
    body1: tokenData.tokens.typography.body,
    body2: tokenData.tokens.typography.bodySm,
    caption: tokenData.tokens.typography.caption,
    button: tokenData.tokens.typography.label,
    label: tokenData.tokens.typography.label,
    labelSm: tokenData.tokens.typography.labelSm,
    labelLg: tokenData.tokens.typography.labelLg,
    subtitle1: tokenData.tokens.typography.body,
    subtitle2: tokenData.tokens.typography.bodySm,
    iconSm: tokenData.tokens.typography.iconSm,
    icon: tokenData.tokens.typography.icon,
    iconLg: tokenData.tokens.typography.iconLg,
    chip: tokenData.tokens.typography.chip
};
export let typographySmall = {
    fontFamily: tokenData.tokens.typography.compact.fontFamily,
    fontSize: 16,
    h1: tokenData.tokens.typography.compact.heading3xl,
    h2: tokenData.tokens.typography.compact.heading2xl,
    h3: tokenData.tokens.typography.compact.headingXl,
    h4: tokenData.tokens.typography.compact.headingLg,
    h5: tokenData.tokens.typography.compact.headingMd,
    h6: tokenData.tokens.typography.compact.heading,
    body1: tokenData.tokens.typography.compact.body,
    body2: tokenData.tokens.typography.compact.bodySm,
    caption: tokenData.tokens.typography.compact.caption,
    button: tokenData.tokens.typography.compact.label,
    label: tokenData.tokens.typography.compact.label,
    labelSm: tokenData.tokens.typography.compact.labelSm,
    labelLg: tokenData.tokens.typography.compact.labelLg,
    subtitle1: tokenData.tokens.typography.compact.body,
    subtitle2: tokenData.tokens.typography.compact.bodySm,
    iconSm: tokenData.tokens.typography.compact.iconSm,
    icon: tokenData.tokens.typography.compact.icon,
    iconLg: tokenData.tokens.typography.compact.iconLg,
    chip: tokenData.tokens.typography.compact.chip
};
export default typography;
